import React from 'react';
import { BasePanel } from './BasePanel.component';
import { RegionType } from './RegionType.enum';

export const CenterPanel = ({ children }) => (
	<BasePanel className="common-layout center-panel" region={RegionType.Center}>
		{children}
	</BasePanel>
);
